<div class="konto-reiter" role="tablist" [attr.aria-label]="'account.reiter.label' | translate">
  @for (id of reiter; track id; let i = $index) {
    <button
      #reiterButton
      type="button"
      role="tab"
      class="konto-reiter__tab"
      [class.konto-reiter__tab--aktiv]="aktiv() === id"
      [id]="'konto-tab-' + id"
      [attr.data-testid]="'konto-tab-' + id"
      [attr.aria-controls]="'konto-panel-' + id"
      [attr.aria-selected]="aktiv() === id"
      [attr.tabindex]="aktiv() === id ? 0 : -1"
      (click)="gewaehlt.emit(id)"
      (keydown)="onKeydown($event, i)"
    >
      {{ 'account.reiter.' + id | translate }}
      @if (id === 'integrationen' && fehlend() > 0) {
        <span class="konto-reiter__badge" data-testid="konto-tab-badge">
          {{ 'account.reiter.fehlt' | translate: { n: fehlend() } }}
        </span>
      }
    </button>
  }
</div>
